import React from 'react';
import { Redirect as ReactRouterRedirect, RedirectProps } from 'react-router-dom';
import * as History from 'history';

type Props = RedirectProps & {
  location?: History.Location;
};

export const Redirect = ({ to, location, ...redirectProps }: Props) => (
  <ReactRouterRedirect
    {...redirectProps}
    to={{ ...location, pathname: typeof to === 'string' ? to : to.pathname }}
  />
);
